import { render } from "./Mail.vue?vue&type=template&id=9a8a9f3a"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
script.render = render

export default script